var map = {
	"./": 72812,
	"./App": 54111,
	"./App.js": 54111,
	"./App.test": 55653,
	"./App.test.js": 55653,
	"./components/AppMainContainer": 13564,
	"./components/AppMainContainer.js": 13564,
	"./components/AppNavigation": 33688,
	"./components/AppNavigation.js": 33688,
	"./components/FontSelector": 60865,
	"./components/FontSelector.js": 60865,
	"./components/InitConfig": 95981,
	"./components/InitConfig.js": 95981,
	"./components/LanguageSwitcher": 49212,
	"./components/LanguageSwitcher.js": 49212,
	"./components/LoginForm": 81002,
	"./components/LoginForm.js": 81002,
	"./components/LoginFormWrapper": 25375,
	"./components/LoginFormWrapper.js": 25375,
	"./components/Modal": 50028,
	"./components/Modal.js": 50028,
	"./components/PasswordChangeForm": 73550,
	"./components/PasswordChangeForm.js": 73550,
	"./components/PdfDocument": 426,
	"./components/PdfDocument.js": 426,
	"./components/PdfForCutting": 18706,
	"./components/PdfForCutting.js": 18706,
	"./components/PdfForStonemasons": 71412,
	"./components/PdfForStonemasons.js": 71412,
	"./components/PdfForStonemasonsBCKP": 58132,
	"./components/PdfForStonemasonsBCKP.js": 58132,
	"./components/Price": 30132,
	"./components/Price.js": 30132,
	"./components/Providers": 65639,
	"./components/Providers.js": 65639,
	"./components/RegistraionForm": 12796,
	"./components/RegistraionForm.js": 12796,
	"./components/ResetPassword": 53011,
	"./components/ResetPassword.js": 53011,
	"./components/SavedConfigurationList": 14462,
	"./components/SavedConfigurationList.js": 14462,
	"./components/SingleLetter": 4653,
	"./components/SingleLetter.js": 4653,
	"./components/TextSection": 13782,
	"./components/TextSection.js": 13782,
	"./components/TextSectionLetters": 16006,
	"./components/TextSectionLetters.js": 16006,
	"./components/TextSectionsList": 22698,
	"./components/TextSectionsList.js": 22698,
	"./components/TolbarActions": 25520,
	"./components/TolbarActions.js": 25520,
	"./components/ToolbarAddSymbol": 44887,
	"./components/ToolbarAddSymbol.js": 44887,
	"./components/ToolbarCustomSelect": 54313,
	"./components/ToolbarCustomSelect.js": 54313,
	"./components/ToolbarWrapper": 26411,
	"./components/ToolbarWrapper.js": 26411,
	"./components/WorkingSizeSelector": 19538,
	"./components/WorkingSizeSelector.js": 19538,
	"./context/ConfigContext": 61521,
	"./context/ConfigContext.js": 61521,
	"./context/EditTypeContext": 62127,
	"./context/EditTypeContext.js": 62127,
	"./context/EditorContext": 8616,
	"./context/EditorContext.js": 8616,
	"./context/LanguageContext": 40477,
	"./context/LanguageContext.js": 40477,
	"./context/LettersContext": 72974,
	"./context/LettersContext.js": 72974,
	"./context/LoaderContext": 49734,
	"./context/LoaderContext.js": 49734,
	"./context/LoginContext": 26878,
	"./context/LoginContext.js": 26878,
	"./context/ModalContext": 11474,
	"./context/ModalContext.js": 11474,
	"./context/PriceCalculationContext": 1417,
	"./context/PriceCalculationContext.js": 1417,
	"./context/PriceContext": 80286,
	"./context/PriceContext.js": 80286,
	"./context/SavedConfigurationsContext": 76497,
	"./context/SavedConfigurationsContext.js": 76497,
	"./context/TextSectionsListContext": 49966,
	"./context/TextSectionsListContext.js": 49966,
	"./context/WorkingSizeContext": 25175,
	"./context/WorkingSizeContext.js": 25175,
	"./data/Config context": 85647,
	"./data/Config context.json": 85647,
	"./data/defaultData": 75183,
	"./data/defaultData.json": 75183,
	"./data/editorToolbarBCKP": 3494,
	"./data/editorToolbarBCKP.json": 3494,
	"./data/fonts": 23600,
	"./data/fonts.json": 23600,
	"./data/price context": 85536,
	"./data/price context.json": 85536,
	"./fonts-raw/Rodlew-ARIALBOLD-20.ttf": 33299,
	"./fonts-raw/Rodlew-ARIALBOLD-25.ttf": 67714,
	"./fonts-raw/Rodlew-ARIALBOLD-30.ttf": 90868,
	"./fonts-raw/Rodlew-ARIALBOLD-40.ttf": 9285,
	"./fonts-raw/Rodlew-ARIALBOLD-50.ttf": 55166,
	"./fonts-raw/Rodlew-ARIALBOLD-60.ttf": 23775,
	"./fonts-raw/Rodlew-ARIALBOLD-CLR-25.ttf": 67148,
	"./fonts-raw/Rodlew-ARIALBOLD-CLR-30.ttf": 79094,
	"./fonts-raw/Rodlew-ARIALBOLD-CLR-40.ttf": 83499,
	"./fonts-raw/Rodlew-ARIALBOLD-CLR-50.ttf": 76812,
	"./fonts-raw/Rodlew-ARIALBOLD-CLR-60.ttf": 75569,
	"./fonts-raw/Rodlew-CORSIVA-CLR-20.ttf": 32916,
	"./fonts-raw/Rodlew-CORSIVA-CLR-25.ttf": 60997,
	"./fonts-raw/Rodlew-CORSIVA-CLR-30.ttf": 75347,
	"./fonts-raw/Rodlew-CORSIVA-CLR-35.ttf": 9762,
	"./fonts-raw/Rodlew-CORSIVA-CLR-40.ttf": 80862,
	"./fonts-raw/Rodlew-CORSIVA-CLR-50.ttf": 51333,
	"./fonts-raw/Rodlew-CORSIVA-CLR-60.ttf": 34816,
	"./fonts-raw/Rodlew-RODLEW-CLR-20.ttf": 43446,
	"./fonts-raw/Rodlew-RODLEW-CLR-25.ttf": 61311,
	"./fonts-raw/Rodlew-RODLEW-CLR-30.ttf": 70397,
	"./fonts-raw/Rodlew-RODLEW-CLR-40.ttf": 24812,
	"./fonts-raw/Rodlew-RODLEW-CLR-50.ttf": 47851,
	"./fonts-raw/Rodlew-RODLEW-CLR-60.ttf": 82378,
	"./fonts-raw/Rodlew-ROMANO-CLR-20.ttf": 62731,
	"./fonts-raw/Rodlew-ROMANO-CLR-25.ttf": 40538,
	"./fonts-raw/Rodlew-ROMANO-CLR-30.ttf": 56044,
	"./fonts-raw/Rodlew-ROMANO-CLR-35.ttf": 20509,
	"./fonts-raw/Rodlew-ROMANO-CLR-40.ttf": 10845,
	"./fonts-raw/Rodlew-ROMANO-CLR-50.ttf": 78230,
	"./fonts-raw/Rodlew-ROMANO-CLR-60.ttf": 32375,
	"./fonts-raw/Rodlew-SZEROKIE-CLR-20.ttf": 39587,
	"./fonts-raw/Rodlew-SZEROKIE-CLR-25.ttf": 38354,
	"./fonts-raw/Rodlew-SZEROKIE-CLR-35.ttf": 24213,
	"./fonts-raw/Rodlew-SZEROKIE-CLR-40.ttf": 14549,
	"./fonts-raw/Rodlew-SZEROKIE-CLR-50.ttf": 15694,
	"./fonts-raw/Rodlew-SZEROKIE-CLR-60.ttf": 66959,
	"./fonts-raw/Rodlew-WASKIE-CLR-20.ttf": 85045,
	"./fonts-raw/Rodlew-WASKIE-CLR-25.ttf": 74756,
	"./fonts-raw/Rodlew-WASKIE-CLR-30.ttf": 32942,
	"./fonts-raw/Rodlew-WASKIE-CLR-40.ttf": 62499,
	"./fonts-raw/Rodlew-WASKIE-CLR-50.ttf": 84420,
	"./fonts-raw/Rodlew-WASKIE-CLR-60.ttf": 73321,
	"./fonts/Montserrat-Italic.woff": 59523,
	"./fonts/Montserrat-Italic.woff2": 60475,
	"./fonts/Montserrat-Light.woff": 2253,
	"./fonts/Montserrat-Light.woff2": 39669,
	"./fonts/Montserrat-Regular.woff": 96469,
	"./fonts/Montserrat-Regular.woff2": 66477,
	"./fonts/Montserrat-SemiBold.woff": 57878,
	"./fonts/Montserrat-SemiBold.woff2": 55840,
	"./fonts/Montserrat-SemiBoldItalic.woff": 68418,
	"./fonts/Montserrat-SemiBoldItalic.woff2": 10724,
	"./fonts/Montserrat-Thin.woff": 79672,
	"./fonts/Montserrat-Thin.woff2": 28202,
	"./fonts/Rodlew-ARIALBOLD-20.otf": 20301,
	"./fonts/Rodlew-ARIALBOLD-25.otf": 98044,
	"./fonts/Rodlew-ARIALBOLD-30.otf": 61638,
	"./fonts/Rodlew-ARIALBOLD-40.otf": 30319,
	"./fonts/Rodlew-ARIALBOLD-50.otf": 23480,
	"./fonts/Rodlew-ARIALBOLD-60.otf": 20401,
	"./fonts/Rodlew-ARIALBOLD-CLR-25.ttf": 48285,
	"./fonts/Rodlew-ARIALBOLD-CLR-30.ttf": 90507,
	"./fonts/Rodlew-ARIALBOLD-CLR-40.ttf": 6006,
	"./fonts/Rodlew-ARIALBOLD-CLR-50.ttf": 38621,
	"./fonts/Rodlew-ARIALBOLD-CLR-60.ttf": 12056,
	"./fonts/Rodlew-CORSIVA-20.otf": 71588,
	"./fonts/Rodlew-CORSIVA-25.otf": 70453,
	"./fonts/Rodlew-CORSIVA-30.otf": 66987,
	"./fonts/Rodlew-CORSIVA-35.otf": 61114,
	"./fonts/Rodlew-CORSIVA-40.otf": 59594,
	"./fonts/Rodlew-CORSIVA-50.otf": 46353,
	"./fonts/Rodlew-CORSIVA-60.otf": 76280,
	"./fonts/Rodlew-CORSIVA-CLR-20.ttf": 52209,
	"./fonts/Rodlew-CORSIVA-CLR-25.ttf": 19560,
	"./fonts/Rodlew-CORSIVA-CLR-30.ttf": 62602,
	"./fonts/Rodlew-CORSIVA-CLR-35.ttf": 21499,
	"./fonts/Rodlew-CORSIVA-CLR-40.ttf": 20343,
	"./fonts/Rodlew-CORSIVA-CLR-50.ttf": 72248,
	"./fonts/Rodlew-CORSIVA-CLR-60.ttf": 98813,
	"./fonts/Rodlew-KURSYWA-20.otf": 59435,
	"./fonts/Rodlew-KURSYWA-30.otf": 47684,
	"./fonts/Rodlew-KURSYWA-35.otf": 62901,
	"./fonts/Rodlew-KURSYWA-CLR-20.otf": 9229,
	"./fonts/Rodlew-KURSYWA-CLR-25.otf": 80028,
	"./fonts/Rodlew-KURSYWA-CLR-30.otf": 76742,
	"./fonts/Rodlew-KURSYWA-CLR-35.otf": 55663,
	"./fonts/Rodlew-RODLEW-20.otf": 9756,
	"./fonts/Rodlew-RODLEW-25.otf": 54394,
	"./fonts/Rodlew-RODLEW-30.otf": 57411,
	"./fonts/Rodlew-RODLEW-40.otf": 13154,
	"./fonts/Rodlew-RODLEW-50.otf": 5225,
	"./fonts/Rodlew-RODLEW-60.otf": 13584,
	"./fonts/Rodlew-RODLEW-CLR-20.ttf": 27193,
	"./fonts/Rodlew-RODLEW-CLR-25.ttf": 84368,
	"./fonts/Rodlew-RODLEW-CLR-30.ttf": 94770,
	"./fonts/Rodlew-RODLEW-CLR-40.ttf": 70687,
	"./fonts/Rodlew-RODLEW-CLR-50.ttf": 608,
	"./fonts/Rodlew-RODLEW-CLR-60.ttf": 13189,
	"./fonts/Rodlew-ROMANO-20.otf": 84509,
	"./fonts/Rodlew-ROMANO-25.otf": 15308,
	"./fonts/Rodlew-ROMANO-30.otf": 40534,
	"./fonts/Rodlew-ROMANO-35.otf": 43167,
	"./fonts/Rodlew-ROMANO-40.otf": 52831,
	"./fonts/Rodlew-ROMANO-50.otf": 52936,
	"./fonts/Rodlew-ROMANO-60.otf": 21217,
	"./fonts/Rodlew-ROMANO-CLR-20.ttf": 67100,
	"./fonts/Rodlew-ROMANO-CLR-25.ttf": 41677,
	"./fonts/Rodlew-ROMANO-CLR-30.ttf": 7387,
	"./fonts/Rodlew-ROMANO-CLR-35.ttf": 96906,
	"./fonts/Rodlew-ROMANO-CLR-40.ttf": 10886,
	"./fonts/Rodlew-ROMANO-CLR-50.ttf": 76775,
	"./fonts/Rodlew-ROMANO-CLR-60.ttf": 98536,
	"./fonts/Rodlew-SZEROKIE-20.otf": 84297,
	"./fonts/Rodlew-SZEROKIE-25.otf": 48320,
	"./fonts/Rodlew-SZEROKIE-35.otf": 40275,
	"./fonts/Rodlew-SZEROKIE-40.otf": 34211,
	"./fonts/Rodlew-SZEROKIE-50.otf": 16572,
	"./fonts/Rodlew-SZEROKIE-60.otf": 44741,
	"./fonts/Rodlew-SZEROKIE-CLR-20.ttf": 17336,
	"./fonts/Rodlew-SZEROKIE-CLR-25.ttf": 17921,
	"./fonts/Rodlew-SZEROKIE-CLR-35.ttf": 6126,
	"./fonts/Rodlew-SZEROKIE-CLR-40.ttf": 7466,
	"./fonts/Rodlew-SZEROKIE-CLR-50.ttf": 65009,
	"./fonts/Rodlew-SZEROKIE-CLR-60.ttf": 66252,
	"./fonts/Rodlew-WASKIE-20.otf": 32371,
	"./fonts/Rodlew-WASKIE-25.otf": 80546,
	"./fonts/Rodlew-WASKIE-30.otf": 42444,
	"./fonts/Rodlew-WASKIE-40.otf": 55385,
	"./fonts/Rodlew-WASKIE-50.otf": 46802,
	"./fonts/Rodlew-WASKIE-60.otf": 76791,
	"./fonts/Rodlew-WASKIE-CLR-20.ttf": 39726,
	"./fonts/Rodlew-WASKIE-CLR-25.ttf": 88535,
	"./fonts/Rodlew-WASKIE-CLR-30.ttf": 91829,
	"./fonts/Rodlew-WASKIE-CLR-40.ttf": 91204,
	"./fonts/Rodlew-WASKIE-CLR-50.ttf": 69283,
	"./fonts/Rodlew-WASKIE-CLR-60.ttf": 75426,
	"./hooks/usePriceCalculation": 84798,
	"./hooks/usePriceCalculation.js": 84798,
	"./images/+.svg": 41564,
	"./images/+hover.svg": 28090,
	"./images/-.svg": 19826,
	"./images/-hover.svg": 34456,
	"./images/40-lat-ico.svg": 8757,
	"./images/45-lat.svg": 53264,
	"./images/EU.svg": 96795,
	"./images/Ellipse.png": 78745,
	"./images/LOGO BIAŁE_CZARNE TŁO.jpg": 79592,
	"./images/LOGO CZARNE_BIAŁE TŁO.jpg": 65610,
	"./images/LOGO KOLOR_BIAŁE TŁO.jpg": 41352,
	"./images/LOGO KOLOR_CZARNE TŁO.jpg": 33773,
	"./images/UR4.jpg": 52044,
	"./images/accessibility.png": 4763,
	"./images/arrow-down-b.svg": 98620,
	"./images/arrow-down-hover.svg": 22200,
	"./images/arrow-down-white.svg": 62641,
	"./images/arrow-down.svg": 38093,
	"./images/arrow-left-d.svg": 46817,
	"./images/arrow-left-w.svg": 89218,
	"./images/arrow-right-b.svg": 19476,
	"./images/arrow-right-d.svg": 68874,
	"./images/arrow-right-w-hover.svg": 39092,
	"./images/arrow-right-w.svg": 88073,
	"./images/ask.svg": 36320,
	"./images/basket-ico-hover.svg": 92994,
	"./images/basket-ico.svg": 23595,
	"./images/blog-bg.jpg": 31015,
	"./images/center.svg": 87182,
	"./images/check.svg": 84811,
	"./images/cookies.svg": 18498,
	"./images/darmowa-dostawa-ico.svg": 63406,
	"./images/double-arrow.png": 82768,
	"./images/envelope.svg": 65537,
	"./images/eu.jpg": 11817,
	"./images/eu.png": 14513,
	"./images/eu2.png": 47031,
	"./images/facebook-ico-hover.svg": 19012,
	"./images/facebook-ico.svg": 96217,
	"./images/filters.svg": 64794,
	"./images/gold-ico.svg": 16159,
	"./images/home.png": 36574,
	"./images/info-ico.svg": 60521,
	"./images/instagram-ico-hover.svg": 94138,
	"./images/instagram-ico.svg": 50195,
	"./images/kup-teraz-ico.svg": 36388,
	"./images/left.svg": 8594,
	"./images/logo.png": 20678,
	"./images/polska-firma-rodzinna-ico.svg": 49597,
	"./images/r-0001.webp": 31905,
	"./images/right-arrow.png": 3361,
	"./images/right.png": 6701,
	"./images/right.svg": 361,
	"./images/search-ico.svg": 63741,
	"./images/silver-ico.svg": 73750,
	"./images/triangle.svg": 93025,
	"./images/wysoka-jakosc-ico.svg": 52131,
	"./images/youtube-ico-hover.svg": 22621,
	"./images/youtube-ico.svg": 1912,
	"./index": 72812,
	"./index.css": 59555,
	"./index.js": 72812,
	"./mockups/configurations": 34399,
	"./mockups/configurations.json": 34399,
	"./mockups/fonts_data": 29659,
	"./mockups/fonts_data.json": 29659,
	"./reportWebVitals": 89031,
	"./reportWebVitals.js": 89031,
	"./services/ConfigurationsService": 4231,
	"./services/ConfigurationsService.js": 4231,
	"./services/FontsMapper": 62222,
	"./services/FontsMapper.js": 62222,
	"./services/PriceService": 96753,
	"./services/PriceService.js": 96753,
	"./services/WCData": 66379,
	"./services/WCData.js": 66379,
	"./services/WCLoginService": 12215,
	"./services/WCLoginService.js": 12215,
	"./services/helpers": 79196,
	"./services/helpers.js": 79196,
	"./services/helpersBCKP": 59052,
	"./services/helpersBCKP.js": 59052,
	"./setupTests": 89472,
	"./setupTests.js": 89472,
	"./styles/abstracts/_functions.scss": 20755,
	"./styles/abstracts/_media-query.scss": 85499,
	"./styles/abstracts/_mixins.scss": 77572,
	"./styles/abstracts/_variables.scss": 75275,
	"./styles/abstracts/index.scss": 175,
	"./styles/base/_base.scss": 67951,
	"./styles/base/_reset.scss": 29541,
	"./styles/base/_typography.scss": 79695,
	"./styles/base/index.scss": 85167,
	"./styles/common/_fonts.scss": 62748,
	"./styles/common/index.scss": 93755,
	"./styles/components/_add-to-cart-with-icon.scss": 70730,
	"./styles/components/_app.scss": 25442,
	"./styles/components/_articles_and_posts_tiles.scss": 25864,
	"./styles/components/_breadcrumbs.scss": 35923,
	"./styles/components/_color-picker.scss": 66539,
	"./styles/components/_contact-form-7.scss": 33514,
	"./styles/components/_container.scss": 18366,
	"./styles/components/_custom-select.scss": 95863,
	"./styles/components/_delivery_time.scss": 75649,
	"./styles/components/_editor-top.scss": 22240,
	"./styles/components/_epitafia-slider.scss": 11212,
	"./styles/components/_faq-form.scss": 74842,
	"./styles/components/_faq.scss": 78237,
	"./styles/components/_fonts-selector.scss": 58175,
	"./styles/components/_gallery.scss": 83443,
	"./styles/components/_heading-section.scss": 98617,
	"./styles/components/_heading.scss": 97867,
	"./styles/components/_home-slider.scss": 56846,
	"./styles/components/_img.scss": 10122,
	"./styles/components/_language-switcher.scss": 12339,
	"./styles/components/_link-with-arrow.scss": 6670,
	"./styles/components/_loader.scss": 16292,
	"./styles/components/_map-text-section.scss": 7923,
	"./styles/components/_map.scss": 84119,
	"./styles/components/_modal.scss": 48512,
	"./styles/components/_nav-actions.scss": 95602,
	"./styles/components/_nav-desktop.scss": 41965,
	"./styles/components/_nav.scss": 22303,
	"./styles/components/_navigation.scss": 30949,
	"./styles/components/_post_related_posts.scss": 59305,
	"./styles/components/_post_related_posts_backup_03-11_12-33-31.scss": 32053,
	"./styles/components/_post_text.scss": 58961,
	"./styles/components/_post_text_field.scss": 56458,
	"./styles/components/_products-category-list.scss": 72481,
	"./styles/components/_quote-for-image.scss": 99683,
	"./styles/components/_quote-for-image_backup_03-07_08-07-05.scss": 46027,
	"./styles/components/_select-margin.scss": 86224,
	"./styles/components/_single-letter-container.scss": 72888,
	"./styles/components/_single-letter.scss": 44922,
	"./styles/components/_social-share.scss": 69926,
	"./styles/components/_team_list.scss": 60011,
	"./styles/components/_team_member.scss": 19449,
	"./styles/components/_text-editor.scss": 72674,
	"./styles/components/_text-section-list.scss": 95489,
	"./styles/components/_text-section.scss": 33422,
	"./styles/components/_tiles-with-icons.scss": 61656,
	"./styles/components/_woocommerce-category-badge.scss": 4002,
	"./styles/components/_woocommerce-loop.scss": 69034,
	"./styles/components/_woocommerce-single-products-gallery.scss": 77532,
	"./styles/components/_woocommerce-variable-info.scss": 88371,
	"./styles/components/_woocommerce-variation-price-html.scss": 6893,
	"./styles/components/_woocommerce.scss": 85569,
	"./styles/components/_wooocommerce-pagination.scss": 85315,
	"./styles/components/_wooocommerce-single-product.scss": 80185,
	"./styles/components/index.scss": 20450,
	"./styles/index.scss": 99815,
	"./styles/ui/_buttons.scss": 68274,
	"./styles/ui/_control.scss": 64854,
	"./styles/ui/_inputs.scss": 48548,
	"./styles/ui/index.scss": 95400,
	"./styles/vendors/index.scss": 35839,
	"./translations/en": 10389,
	"./translations/en.json": 10389,
	"./translations/it": 34895,
	"./translations/it.json": 34895,
	"./translations/pl": 99026,
	"./translations/pl.json": 99026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;